document.addEventListener("DOMContentLoaded", function () {
    console.log("Custom.js is running!"); 

    // if (!window.location.pathname.includes('/collections/')) {
      function applyHoverEffect() {
        console.log('hover works')
        
        const images = document.querySelectorAll('.product__img, .zoom-image');
        console.log("images found:", images.length)

        // if (images.length === 0) {
        //   console.log("nothing found");
        //   setTimeout(applyHoverEffect, 500);
        //   return;
        // }

        images.forEach((img) => {
          if (!img.dataset.zoomAttached) {
            console.log('image detected', img.src);
            img.dataset.zoomAttached = "true";

          img.addEventListener('mouseover', function () {
          console.log('hover dected', img.src);
          // img.style.transform = 'scale(2.5)';
          img.style.transition = 'transform 0.3s ease-in-out';
        });
            
          img.addEventListener('mouseout', function () {
            img.style.transform = '';
            img.style.transformOrigin = 'center';
        });

            img.addEventListener('mousemove', function (event) {
              console.log('mouse moving', img.src);
              
              const rect = img.getBoundingClientRect();
              const x = ((event.clientX - rect.left) / rect.width) * 100;
              const y = ((event.clientY - rect.top) / rect.height) * 100;

              img.style.transform = `scale(2.5) translate(${(50 - x) / 5}%, ${(50 - y) / 5}%)`;
              img.style.transformOrigin = 'center';
            });
          }
        });
      }
      setTimeout(applyHoverEffect, 100);
        // document.addEventListener("mouseover", function (event) {
        //     const target = event.target;

        //     if (target.tagName === "IMG" && target.classList.contains("product__img")) {
        //         console.log("Hover detected on product image:", target.src);
        //         target.style.transition = "transform 0.5s ease"; 
        //         target.style.transform = "scale(1.2)";
        //     }
        // });
      const observer = new MutationObserver(applyHoverEffect);
      observer.observe(document.body, {childList: true, subtree: true});
// }
});
      

        // document.addEventListener("mouseout", function (event) {
        //     const target = event.target;

        //     // Reset zoom when the mouse leaves the image
        //     if (target.tagName === "IMG" && target.classList.contains("product__img")) {
        //         console.log("Mouse left the image:", target.src);
        //         target.style.transition = "transform 0.5s ease";
        //         target.style.transform = "scale(1)";
        //     }
        // });